export const ItemCategory = `ItemCategory`;
export const ItemSection = `ItemSection`;
export const ItemBrand = `ItemBrand`;
export const ItemClass1 = `ItemClass1`;
export const ItemClass2 = `ItemClass2`;
export const ItemClass3 = `ItemClass3`;
export const ItemClass4 = `ItemClass4`;
export const ItemClass5 = `ItemClass5`;
export const ItemClass6 = `ItemClass6`;
export const ItemClass7 = `ItemClass7`;
export const ItemClass8 = `ItemClass8`;
export const ItemClass9 = `ItemClass9`;
export const ItemClass10 = `ItemClass10`;
export const InvItem = `InvItem`;
export const SalesInvoice = `SalesInvoice`;
